export const TRANSLATION_PREFIX = "multi-deposit-limit";
export const NOT_SET_TRANSLATION_KEY = `${TRANSLATION_PREFIX}.placeholder`;

export const enum MultiDepositLimitType {
	Current = "current",
	Upcoming = "upcoming",
}

export const DEPOSIT_LIMIT_CONFIRMATION_ALERT_ID = "DEPOSIT_LIMIT_CONFIRMATION_ALERT_ID";
